import appConfigStoreModule from "@core/@app-config/appConfigStoreModule";
import { fieldParams, formData, postData, querySearch } from "@utils";
import Vue from "vue";
import Vuex from "vuex";
import app from "./app";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userRole: [
      {
        slug: "CUST",
        name: "Kullanıcı",
      },
      {
        slug: "COMM",
        name: "Kurumsal",
      },
      {
        slug: "FIN",
        name: "Finans",
      },
      {
        slug: "SUPER",
        name: "Admin",
      },
      {
        slug: "CALLC",
        name: "Call Center",
      },
      {
        slug: "DIST",
        name: "Bölge Yöneticisi",
      },
      {
        slug: "MNGR",
        name: "Yönetici",
      },
      {
        slug: "PLSYR",
        name: "Plasiyer",
      },
      {
        slug: "DEAL",
        name: "Bayi",
      },
      {
        slug: "SUBE",
        name: "Şube",
      },
      {
        slug: "BAYI",
        name: "Bayi",
      },
    ],
    tanimlar: {
      durum: [
        {
          text: "Aktif",
          value: "1",
        },
        {
          text: "Pasif",
          value: "0",
        },
      ],
      birim: [
        {
          text: "Adet",
          value: "AD",
        },
        {
          text: "Litre",
          value: "LT",
        },
        {
          text: "Teneke",
          value: "TIN",
        },
        {
          text: "SC",
          value: "SC",
        },
        {
          text: "Koli",
          value: "KL",
        },
        {
          text: "Kg",
          value: "KG",
        },
        {
          text: "Paket",
          value: "PK",
        },
        {
          text: "Kutu",
          value: "KT",
        },
        {
          text: "Tepsi",
          value: "TPS",
        },
      ],
      para: [
        {
          text: "TL",
          value: "TL",
        },
      ],
      kdv: [
        {
          text: "%20",
          value: "20.00",
        },
        {
          text: "%18",
          value: "18.00",
        },
        {
          text: "%10",
          value: "10.00",
        },
        {
          text: "%8",
          value: "8.00",
        },
        {
          text: "%1",
          value: "1.00",
        },
        {
          text: "%0",
          value: "0.00",
        },
      ],
      fabrika: [
        {
          text: "Tekirdağ",
          value: "01",
        },
        {
          text: "Konya",
          value: "02",
        },
      ],
      odemeDurum: [
        {
          text: "Kredi Kartı",
          value: "1",
        },
        {
          text: "Havale",
          value: "2",
        },
      ],
      siparisDurum: [
        {
          text: "Bekliyor",
          value: "1",
          color: "warning",
          outlined: false,
        },
        {
          text: "Ödeme Bekleniyor",
          value: "9",
          color: "warning",
          outlined: true,
        },
        {
          text: "Onaylandı",
          value: "2",
          color: "success",
          outlined: false,
        },
        {
          text: "Üretime Alındı",
          value: "14",
          color: "info",
          outlined: true,
        },
        {
          text: "Kesim Yapılıyor",
          value: "15",
          color: "info",
          outlined: false,
        },
        {
          text: "İptal Edildi",
          value: "4",
          color: "error",
          outlined: false,
        },
        {
          text: "Limit Yetersiz",
          value: "5",
          color: "error",
          outlined: true,
        },
        {
          text: "Kart Bilgileri Yanlış",
          value: "6",
          color: "error",
          outlined: false,
        },
        {
          text: "Havale Bekleniyor",
          value: "7",
          color: "warning",
          outlined: true,
        },
        {
          text: "İletişim Bilgileri Yanlış",
          value: "8",
          color: "warning",
          outlined: true,
        },
        {
          text: "Siparişiniz kargoya verildi",
          value: "10",
          color: "success",
          outlined: true,
        },
        {
          text: "Siparişiniz Hazır, Teslim Alabilirsiniz",
          value: "16",
          color: "success",
          outlined: false,
        },
        {
          text: "Sipariş teslim edildi",
          value: "11",
          color: "success",
          outlined: false,
        },
        {
          text: "İade Edildi",
          value: "12",
          color: "error",
          outlined: false,
        },
        {
          text: "İade için onay bekliyor",
          value: "13",
          color: "warning",
          outlined: true,
        },
      ],
    },
    plasiyerCustomer: null,
    riskTutar: null,
    riskDur: null,
    riskLoading: false,
    generalDisabled: false,
  },
  getters: {
    isCustomer(state) {
      const userData = JSON.parse(localStorage.getItem("userData"));
      let result = false;
      if (userData.role === "SUPER") {
        result = true;
      }
      if (state.plasiyerCustomer) {
        result = true;
      } else if (
        userData.role === "BAYI" ||
        userData.role === "SUBE" ||
        userData.role === "COMM" ||
        userData.role === "COMUSR"
      ) {
        result = true;
      }
      return result;
    },
  },
  mutations: {
    PLASIYER_CUSTOMER(state, value) {
      state.plasiyerCustomer = value;
    },
    RISK_TUTAR(state, value) {
      state.riskTutar = value;
    },
    RISK_DUR(state, value) {
      state.riskDur = value;
    },
    RISK_LOADING(state, value) {
      state.riskLoading = value;
    },
    GENERAL_DISABLED(state, value) {
      state.generalDisabled = value;
    },
  },
  actions: {
    refreshRiskLimit({ state, commit, dispatch }) {
      const previousTutar = state.riskTutar;
      const previousDur = state.riskDur;

      if (previousTutar == null) {
        commit("RISK_LOADING", true);
      }

      return dispatch("postMethod", { method: "riskOrderCalculate" })
        .then((response) => {
          if (response.error == 0) {
            const newTutar = response.detail.calculatedRisk;
            const newDur = response.detail.stopOrdering;
            const hasChanged = previousTutar !== newTutar || previousDur !== newDur;

            commit("RISK_TUTAR", newTutar);
            commit("RISK_DUR", newDur);

            if (previousTutar != null && hasChanged) {
              commit("RISK_LOADING", true);
              setTimeout(() => commit("RISK_LOADING", false), 800);
            } else if (previousTutar == null) {
              commit("RISK_LOADING", false);
            }
          } else if (previousTutar == null) {
            commit("RISK_LOADING", false);
          }
          return response;
        })
        .catch((error) => {
          commit("RISK_LOADING", false);
          throw error;
        });
    },
    syncCustomerLimit(ctx, { callTo } = {}) {
      const data = { method: "updateCustomerLimit" };
      if (callTo) data.callTo = callTo;

      return postData(data).then((response) => {
        if (response.error) {
          return ctx.dispatch("refreshRiskLimit");
        }
        return null;
      });
    },
    postMethod(ctx, data) {
      return new Promise((resolve, reject) => {
        postData(data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    uploadMethod(ctx, data) {
      return new Promise((resolve, reject) => {
        formData(data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchMethod(ctx, { query, method }) {
      return new Promise((resolve, reject) => {
        postData(querySearch(query, method))
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    addUpdateMethod(ctx, { data, search, method, id = "" }) {
      return new Promise((resolve, reject) => {
        postData(fieldParams(data, search, method, id))
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  modules: {
    appConfig: appConfigStoreModule,
    app,
  },
});
